export const ParameterizeMixin = {
	methods: {
		parameterize(item, mode) {
			return item
				.trim()
				.toLowerCase()
				.replace(/[^a-z0-9]/gi, mode)
				.replace(/\s/g, mode)
				.replace(/(_|-)+/g, mode)
		},
	},
}
